import { jsx as r } from "react/jsx-runtime";
import { Breadcrumbs as t, ChevronIcon as m } from "./styles57.mjs";
const n = ({ variant: o, ...e }) => /* @__PURE__ */ r(
  t,
  {
    ...e,
    separator: /* @__PURE__ */ r(m, { fontSize: "small" }),
    $outline: o === "outline"
  }
);
export {
  n as Breadcrumbs
};
//# sourceMappingURL=index84.mjs.map
